<div class="container">
	<div class="row">
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Recalculate asset states</div>
				<div class="content">
					<div class="row">
						<div class="col-sm-5">
							<app-action-button [action]="RecalculateStates" [context]="this" processing="Recalculating..."
								complete="States recalculated">Recalculate All Asset States</app-action-button>
						</div>
						<div class="col-sm-7">
							<p *ngIf="calcStatus">
								<ngb-progressbar type="success" [value]="calcProgress"></ngb-progressbar>
							</p>
							{{calcStatus}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>